<template>
	<div class="codeButton" :class="{disabled: countdownDuration > 0}" @click="onButtonClick">{{buttonText}}</div>
</template>

<script>
export default{
	props: ['buttonClick'],
	data(){
		return {
			buttonText: '获取验证码',
			countdownDuration: 0
		}
	},
	watch: {
		countdownDuration(nTime){
			if(nTime <= 0){
				this.buttonText = '获取验证码'
			}else{
				this.buttonText = `${nTime} s`
			}
		}
	},
	destroyed(){
		this.intervalTimer && clearInterval(this.intervalTimer)
	},
	methods: {
		onButtonClick(){
			this.buttonClick && this.buttonClick()
		},
		reset(){
			this.buttonText = '获取验证码'
			this.countdownDuration = 0
			this.intervalTimer && clearInterval(this.intervalTimer)
		},
		countdown(time){
			this.countdownDuration = time
			this.intervalTimer = setInterval(() => {
				this.countdownDuration --
				if(this.countdownDuration <= 0){
					clearInterval(this.intervalTimer)
					this.countdownDuration = 0
				}
			}, 1000)
		},
	}
}
</script>

<style scoped>
.codeButton{
	display: inline-block;
	min-width: 80px;
	padding: 0 5px;
	font-size: 14px;
	color: #f00;
	line-height: 1.5;
	text-align: center;
	white-space: nowrap;
	border: 1px solid #f00;
	border-radius: 20px;
	cursor: pointer;
}
.disabled{
	color: #ccc;
	border-color: #ccc;
}
</style>